export const api = {
    comments: (): string => '/api/comments/',
    comment: (uuid: string): string => `/api/comments/${uuid}/`,
    commentsByFilter: (): string => '/api/comment_threads/',
    commentsByThread: (threadId: string): string => `/api/comment_threads/${threadId}/`,
    commentsMentionableMembers: (meetingId: string, filterTypeWithId: string): string =>
        `/api/comment_threads/mentionable/?event_id=${meetingId}&${filterTypeWithId}&order_by=last_name`,
    getMeetingCommentsCount: (
        meetingId: string,
        options?: { mode?: string; includeDocuments?: boolean }
    ): string =>
        `/api/comment_threads/agenda/counts/${meetingId}/?mode=${options?.mode ?? 'draft'}&include_documents=${options?.includeDocuments}`,
    reaction: (commentId: string, emoji: string): string =>
        `/api/comments/agenda/${commentId}/reactions/${emoji}/`,
    setCommentAsRead: (): string => `/api/comments/mark_as_read/`
};
